const TYPES = {
  I: 'Individual (Titular)',
  M: 'Mancomunado',
  O: 'Boligatorio solidario',
  A: 'Aval',
  T: 'Titular con aval',
};

export default type => TYPES[type] || type;
